import { render } from "./VF-checkbox.vue?vue&type=template&id=f1889b84"
import script from "./VF-checkbox.vue?vue&type=script&lang=js"
export * from "./VF-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__